<template>
  <div class="container py-5 text-center">
    <p class="mb-3">
      Use the reset link from your email to set a new password, or request a new
      one below.
    </p>
    <router-link to="/forgot_password" class="btn btn-sm btn-success">
      Forgot password
    </router-link>
    <router-link to="/sign-in" class="btn btn-sm btn-outline-secondary ms-2">
      Sign in
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ResetPassword",
};
</script>
